import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Reporting",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.86 29H1c-.63 0-1.14-.51-1.14-1.14V17.57c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v10.29C9 28.49 8.49 29 7.86 29m-5.72-2.28h4.57v-8H2.14zM19.29 29h-6.86c-.63 0-1.14-.51-1.14-1.14v-16c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v16c0 .63-.51 1.14-1.14 1.14m-5.72-2.28h4.57V13.01h-4.57zM30.71 29h-6.86c-.63 0-1.14-.51-1.14-1.14V5c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v22.86c0 .63-.51 1.14-1.14 1.14M25 26.71h4.57V6.14H25z"
    })
  }));
};
ReportingIcon.displayName = 'ReportingIcon';